import { useEffect, useMemo } from "react";
import type { AppConfig } from "../../core/types/config";
import type { WidgetEventMap } from "../../core/types/event";
import { WidgetEvents } from "../../services/internal/eventService";
import {
  buildUrlSearchParamsFromSwapEvent,
  parseInitialAssetsFromUrl,
} from "../../services/internal/urlParamsService";

export { buildUrlSearchParamsFromSwapEvent, parseInitialAssetsFromUrl };

/**
 * Reads initial swap assets from URL params on mount, and keeps the URL in
 * sync with swap param changes emitted by the widget.
 */
export const useUrlSwapParams = (): {
  initialAssets: AppConfig["initialAssets"];
} => {
  const initialAssets = useMemo(
    () =>
      typeof window !== "undefined"
        ? parseInitialAssetsFromUrl(new URLSearchParams(window.location.search))
        : undefined,
    []
  );

  useEffect(() => {
    const onSwapParamsChanged = (event: any) => {
      const params = buildUrlSearchParamsFromSwapEvent(
        event?.detail as WidgetEventMap["swapParamsChanged"]
      );
      const qs = params.toString();
      history.pushState({}, "", qs ? "?" + qs : location.pathname);
    };

    WidgetEvents.getInstance().listenToWidget(
      "swapParamsChanged",
      onSwapParamsChanged
    );
    return () => {
      WidgetEvents.getInstance().removeWidgetListener(
        "swapParamsChanged",
        onSwapParamsChanged
      );
    };
  }, []);

  return { initialAssets };
};
